import React from 'react';
import classNames from 'classnames';
import { Icon, LogoWithoutLink } from '@scentregroup/ui';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './use-task-header';
const TaskHeader = _ref => {
  let {
    Link,
    logoType,
    back,
    user,
    logoPosition = 'inline',
    hairline = false,
    disableLinkLogo = false,
    hasBottomMargin = false,
    showUser = true
  } = _ref;
  const bottomPositionedLogo = logoPosition === 'bottom';
  const logoElement = /*#__PURE__*/_jsx(LogoWithoutLink, {
    type: logoType,
    className: classNames(style.logo, logoType && style[logoType] ? {
      [style[logoType]]: true
    } : undefined),
    "data-id": "task-header_index_logoElement_LogoWithoutLink"
  });
  const logoSection = /*#__PURE__*/_jsx("div", {
    className: style.logoSection,
    "data-id": "task-header_index_logoElement_div",
    children: disableLinkLogo ? logoElement : /*#__PURE__*/_jsx(Link, {
      to: "/",
      "data-id": "task-header_index_logoElement_Link",
      children: logoElement
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(style['task-header'], {
      [style.bottomPositionedLogo]: bottomPositionedLogo,
      [style.bottomMargin]: hasBottomMargin,
      [style.hairline]: hairline
    }),
    "data-id": "task-header_index_logoElement_div",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style.header,
      "data-id": "task-header_index_logoElement_div_div_4",
      children: [/*#__PURE__*/_jsx("div", {
        className: style.backSection,
        "data-id": "task-header_index_logoElement_div_div_5",
        children: back && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Link, {
            to: back.url,
            className: classNames(style.link, style.icon),
            onClick: back.onClick,
            "data-id": "task-header_index_logoElement_Link",
            children: /*#__PURE__*/_jsx(Icon, {
              size: "medium",
              type: "arrow-left",
              className: style.icon,
              "data-id": "task-header_index_logoElement_Link_Icon"
            })
          }), /*#__PURE__*/_jsx(Link, {
            to: back.url,
            className: style.link,
            onClick: back.onClick,
            "data-id": "task-header_index_logoElement_Link",
            children: back.label
          })]
        })
      }), bottomPositionedLogo ? null : logoSection, /*#__PURE__*/_jsx("div", {
        className: style.avatarSection,
        "data-id": "task-header_index_logoElement_div_div",
        children: showUser && user && (user === null || user === void 0 ? void 0 : user.firstName) && /*#__PURE__*/_jsx("div", {
          className: style.avatar,
          "data-id": "task-header_index_logoElement_div_10",
          children: user.firstName.charAt(0).toUpperCase()
        })
      })]
    }), bottomPositionedLogo ? logoSection : null]
  });
};
export default TaskHeader;